import { render, staticRenderFns } from "./RequestsPerTimeFrame.vue?vue&type=template&id=24fb4ba0&scoped=true"
import script from "./RequestsPerTimeFrame.vue?vue&type=script&lang=js"
export * from "./RequestsPerTimeFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fb4ba0",
  null
  
)

export default component.exports